package org.btmonier.games.model

import kotlinx.serialization.Serializable

@Serializable
data class Game(
    val metadata: GameMetadata,
    val content: GameContent
)
